import { Routes } from "@angular/router";
import { AuthGuard } from "./core/authentication/guards/auth.guard";

import { AdminGuard } from "./core/authentication/guards/admin.guard";

export const APP_ROUTES: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    loadComponent: () => import("./core/login/login.component").then(m => m.LoginComponent),
  },
  {
    path: "map",
    loadChildren: () => import("./features/map/map.routes").then(m => m.MAP_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: "admin",
    loadChildren: () => import("./features/admin/admin.routes").then(m => m.ADMIN_ROUTES),
    canActivate: [AdminGuard],
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
